export default __webpack_public_path__ + "static/title-image-49d7313d6248859be8140a9e02470b32.jpg";